import Vector2 from '@/models/Vector2'

export class ChangeMapDataPacket
{
    public data = ''
}
export class MapNodeCreateRequest
{
    public title = '';
    public position = new Vector2(0, 0);
}

export class MapNodeEditRequest
{
    public id = 0;
    public title = '';
    public position = new Vector2(0, 0);
}

export class MapNodeDestroy
{
    public id = 0;
}

export class MapNodeCreateResponse
{
    public id = 0;
    public title = '';
    public position = new Vector2(0,0);
}